angular.module('octopusApp.shared', []);


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/shared.js
// module id = 3044010571597539
// module chunks = 1